import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface CarrierChoice {
  carrierCompany: string;
  handlingMode: string;
  [key: string]: unknown;
}

export interface GetClaimContextCarrierQueryArgs {
  claimId: string;
  handlingMode: string;
}

export const getClaimContextCarrierRequest = ({
  claimId,
  handlingMode,
}: GetClaimContextCarrierQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/carriers?mode=${handlingMode}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimContextCarrierQuery = async (
  args: GetClaimContextCarrierQueryArgs,
): Promise<BackResponse<CarrierChoice[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<CarrierChoice[]>>(
      getClaimContextCarrierRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
